module.exports = __webpack_public_path__ + "static/img/aia-cs-pt.7f2e748.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/aia-cs-pt.jpg
// module id = 0Cdr
// module chunks = 0